import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { map, share, finalize, tap, catchError } from 'rxjs/operators';

import { AuthService } from './auth.service';
import { UserService } from '@shared/services/user.service';
import { RequestService } from '@core';
import { UtilsService } from '@shared/services/utils.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  isRefreshed$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    public router: Router,
    private requestService: RequestService,
    private userService: UserService,
    private auth: AuthService,
    private utils: UtilsService
  ) { }

  refresh(mapCallback: Function, isPublic: boolean = false): Observable<boolean> | boolean {

    if (this.isRefreshed$.getValue()) {
      return mapCallback();
    } else {
      this.isRefreshed$.next(true);
      return this.requestService.execRequest('get', 'refresh')
        .pipe(
          tap((response: any) => this.consumeUser(response)),
          map(() => mapCallback()),
          catchError(() => {
            if (!isPublic) {
              this.router.navigate(['/index']);
              return of(false);
            } else {
              return of(true);
            }
          })
        );
    }
  }

  consumeUser(response: any) {
    const user = this.userService.addUser(response);

    if (!user) {
      console.error("Utente non restituito Errore");
      return false;
    }
    this.auth.setLogged(true);
    return true;
  }

  logout(): void {
    this.utils.inLoading(true);
    this.requestService.execRequest("get", 'logout')
      .pipe(finalize(() => this.utils.inLoading(false)))
      .subscribe((logoutUrl) => {
        window.open(logoutUrl, "_self");
      });
  }

  doLogout() {
    this.auth.setLogged(false);
    this.userService.resetUser();
    this.router.navigate(['/index']);
  }
}
